import React, { useEffect, useState } from "react";
import {
    Autocomplete,
    TextField,
    Checkbox,
    Chip,
    Typography,
    Box,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Option } from "../types/OptionType";
import useApplicationStore from "../stores/ApplicationStore";
import ProjectApi from "../api/ProjectApi";
import { useError } from "../utils/functions";

const MultiSelectDropdown: React.FC = () => {
    const { setError } = useError();
    const { selectedOptions, setSelectedOptions } = useApplicationStore();
    const [options, setOptions] = useState<Option[]>([]);

    const handleChange = (event: any, value: Option[]) => {
        setSelectedOptions(value.map((option) => option.value));
    };

    const getAllProject = async () => {
        setOptions([]);

        const res = await ProjectApi.getAllProject();

        if (res) {
            if (res.code) {
                setError(res.message);
            } else {
                const newOptions = Object.values(res).map((obj: any) => ({
                    value: obj.id,
                    label: obj.name
                }));
                setOptions(newOptions);

            }
        }
    };

    useEffect(() => {
        getAllProject();
    }, []);

    return (
        <Autocomplete
            multiple
            id="multi-select-dropdown"
            options={options}
            disableCloseOnSelect
            value={options.filter((option) => selectedOptions.includes(option.value))}
            onChange={handleChange}
            getOptionLabel={(option) => option.label}
            renderOption={(props, option, { selected }) => {
                const { key, ...restProps } = props;
                return (
                    <li key={key} {...restProps}>
                        <Checkbox
                            icon={<CheckBoxOutlineBlankIcon />}
                            checkedIcon={<CheckBoxIcon />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {option.label}
                    </li>
                );
            }}
            renderInput={(params) => (
                <Box>
                    <Typography variant="h6" align="left" gutterBottom>Project to Connect</Typography>
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select projects"
                        required
                    />
                </Box>
            )}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                    const tagProps = getTagProps({ index });
                    const { key, ...restProps } = tagProps;
                    return (
                        <Chip
                            key={key}
                            label={option.label}
                            {...restProps}
                        />
                    );
                })
            }

            sx={{
                "& .MuiAutocomplete-endAdornment": {
                    color: "var(--primary-dark-blue)",
                },
                "& .MuiAutocomplete-popupIndicator": {
                    transform: "rotate(0deg)",
                },
            }}
        />
    );
};

export default MultiSelectDropdown;
